<template>
  <div>
    <div class="page-header page-header-small">
      <parallax class="page-header-image" :style="backgroundTopo"></parallax>
      <div class="content-center">
        <div class="content-center brand">
          <h3 class="h3-seo mt-5">{{ demanda.titulo }}</h3>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <form>
        <b-row class="mx-2">
          <b-col cols="12">
            <div class="mt-3">
              <b-alert
                :show="!demanda.isentoPagamento && pagamento && getTipoArquivoPagamento('CP1').anexo === undefined"
                variant="warning"
              >
                <font-awesome-icon icon="circle-exclamation" class="mr-2" />
                <b>Atenção!</b>
                <br />
                Essa demanda esta aguardando o pagamento !
              </b-alert>
            </div>
          </b-col>

          <b-col cols="12">
            <div class="mt-3">
              <b-alert :show="demanda.isentoPagamento === 1" variant="info">
                <font-awesome-icon icon="info-circle" class="mr-2" />
                <b>Demanda Isenta de Pagamento!</b>
                <br />
                Esta demanda possui isenção de pagamento aprovada.
              </b-alert>
            </div>
          </b-col>

          <b-col cols="9">
            <b-card class="mt-3">
              <div slot="header">
                <b-row>
                  <b-col cols="6">
                    <span class="h5">Solicitante: {{ demanda.usuario.nome }}</span>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <span class="h5 ">Protocolo: {{ demanda.nroProtocolo }}</span>
                  </b-col>
                </b-row>
                <!-- comprovante de abertura disponível somente para quem abriu a solicitação -->
                <b-row v-if="isCriador">
                  <b-col cols="12" class="text-right mt-2">
                    <n-button type="primary" round size="md" @click="solicitarComprovanteAbertura">
                      <font-awesome-icon icon="file-download" />
                      <span class="ml-1">Solicitar comprovante de abertura da solicitação</span>
                    </n-button>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="2">
                  <b-form-group label="Revisão:">
                    <b-form-input v-model="demanda.versaoAtual" :readonly="true" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="2" v-if="!hasHiddenField('kmInicial')">
                  <b-form-group label="KM Inicial:">
                    <b-form-input v-model="demanda.kmInicial" :readonly="true" />
                  </b-form-group>
                </b-col>
                <b-col cols="2" v-if="!hasHiddenField('kmFinal')">
                  <b-form-group label="KM Final:">
                    <b-form-input v-model="demanda.kmFinal" :readonly="true" />
                  </b-form-group>
                </b-col>
                <b-col cols="8" v-if="!hasHiddenField('cidade')">
                  <b-form-group label="Cidade:">
                    <b-form-input v-model="demanda.cidade.descricao" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="7" v-if="!hasHiddenField('rodovia')">
                  <b-form-group label="Rodovia:">
                    <b-input-group>
                      <b-form-input v-model="demanda.trecho.descricao" :readonly="true" />
                      <b-input-group-append>
                        <b-button variant="info" @click="toggleMapDialog">
                          <i class="now-ui-icons location_pin" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="5" v-if="!hasHiddenField('tipo')">
                  <b-form-group :label="labelTipo">
                    <b-form-input v-model="demanda.tipo.descricao" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="6" v-if="!hasHiddenField('objetivo')">
                  <b-form-group :label="labelObjetivo">
                    <b-form-input v-model="demanda.objetivo.descricao" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="6" v-if="!hasHiddenField('local')">
                  <b-form-group label="Local:">
                    <b-form-input :value="getLocalDemanda()" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="6" v-if="!hasHiddenField('area')">
                  <b-form-group label="Área:">
                    <b-form-input v-model="demanda.area.descricao" :readonly="true" />
                  </b-form-group>
                </b-col>
                <b-col cols="6" v-if="!hasHiddenField('nomenclaturaAlca')">
                  <b-form-group label="Nomenclatura Alça:">
                    <b-form-input :value="getNomenclaturaAlca()" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="6" v-if="!hasHiddenField('faixa')">
                  <b-form-group label="Faixa:">
                    <b-form-input :value="getFaixaDemanda()" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="6" v-if="!hasHiddenField('sentido')">
                  <b-form-group label="Sentido:">
                    <b-form-input :value="getSentido()" :readonly="true" />
                  </b-form-group>
                </b-col>
                <!-- campo de número de termo autorizativo -->
                <b-col cols="6" v-if="demanda.numeroTermoAutorizativo">
                  <b-form-group label="Nº de Termo Autorizativo:">
                    <b-form-input v-model="demanda.numeroTermoAutorizativo" :readonly="true" />
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="!hasHiddenField('observacao')">
                  <b-form-group label="Observações:">
                    <b-form-textarea v-model="demanda.observacoes" rows="3" :readonly="true" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="3">
            <b-card
              v-if="
                pagamento &&
                  !demanda.isentoPagamento &&
                  (demanda.valorDemanda !== undefined || demanda.valorDemanda === 0)
              "
              class="mt-3"
              header-bg-variant="primary"
              footer-bg-variant="secondary"
            >
              <div slot="header" class="text-white">
                Informações de pagamento
              </div>
              <b-row v-if="pagamento">
                <b-col v-if="refCodeDemandas.refValue != undefined" cols="12">
                  <b-form-group label="Dados:">
                    <b-form-textarea v-model="refCodeDemandas.refValue" rows="3" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="Valor da taxa PAV:">
                    <b-form-input :value="getValorPagamento(demanda.valorDemanda)" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="Comprovante da taxa PAV:">
                    <b-form-file
                      v-if="getTipoArquivoPagamento('CP1').anexo == undefined"
                      v-model="uploadedFileComprovante"
                      placeholder="Adicionar o comprovante"
                      browse-text="Escolher"
                      id="arquivo-comprovante"
                      name="arquivo-comprovante"
                      :accept="getTypeFile(1)"
                      @input="onUploadComprovante(uploadedFileComprovante, 'CP1')"
                    >
                    </b-form-file>
                    <div v-else>
                      <n-button
                        type="primary"
                        round
                        size="md"
                        class="mb-1"
                        @click="downloadDocto(getTipoArquivoPagamento('CP1').anexo)"
                      >
                        <font-awesome-icon icon="file-download" /> <span class="ml-1">Comprovante</span>
                      </n-button>

                      <n-button
                        v-if="getTipoArquivoPagamento('NF1').anexo != undefined"
                        type="primary"
                        round
                        size="md"
                        class="mb-1 ml-1"
                        @click="downloadDocto(getTipoArquivoPagamento('NF1').anexo)"
                      >
                        <font-awesome-icon icon="file-download" /> <span class="ml-1">Nota fiscal</span>
                      </n-button>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col v-if="demanda.valorAdicional != undefined" cols="12">
                  <b-form-group label="Valor da taxa PEP:">
                    <b-form-input :value="getValorPagamento(demanda.valorAdicional)" :readonly="true" />
                  </b-form-group>
                </b-col>

                <b-col v-if="demanda.valorAdicional != undefined" cols="12">
                  <b-form-group label="Comprovante da taxa PEP:">
                    <b-form-file
                      v-if="getTipoArquivoPagamento('CP2').anexo == undefined"
                      v-model="uploadedFileComprovante"
                      placeholder="Adicionar o comprovante"
                      browse-text="Escolher"
                      id="arquivo-comprovante"
                      name="arquivo-comprovante"
                      :accept="getTypeFile(1)"
                      @input="onUploadComprovante(uploadedFileComprovante, 'CP2')"
                    >
                    </b-form-file>
                    <div v-else>
                      <n-button
                        type="primary"
                        round
                        size="md"
                        class="mb-1"
                        @click="downloadDocto(getTipoArquivoPagamento('CP2').anexo)"
                      >
                        <font-awesome-icon icon="file-download" /> <span class="ml-1">Comprovante</span>
                      </n-button>

                      <n-button
                        v-if="getTipoArquivoPagamento('NF2').anexo != undefined"
                        type="primary"
                        round
                        size="md"
                        class="mb-1 ml-1"
                        @click="downloadDocto(getTipoArquivoPagamento('NF2').anexo)"
                      >
                        <font-awesome-icon icon="file-download" /> <span class="ml-1">Nota fiscal</span>
                      </n-button>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>

            <b-card header-bg-variant="primary" footer-bg-variant="secondary">
              <div slot="header" class="text-white">
                {{ demanda.statusInfo.descricao }}
              </div>

              <b-row class="my-1">
                <b-col cols="12">
                  <span class="p-2 text-muted"
                    ><i class="fas fa-location-arrow icon mr-2"></i>
                    {{ demanda.trecho.descricao + ', do KM ' + demanda.kmInicial + ' ao KM ' + demanda.kmFinal }}
                  </span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <span class="badge badge-default">
              <i class="fas fa-comments mr-1 mt-1 mb-1" />
              Comentários ({{ historicos.length }})
            </span>
          </b-col>
          <b-col cols="9" class="d-flex justify-content-end">
            <n-button type="primary" v-b-modal.publishModal round size="md" class="mb-1">
              <font-awesome-icon icon="comment" />&nbsp;Adicionar comentário
            </n-button>
          </b-col>
          <b-col cols="12">
            <div class="mt-1 mb-1 mr-2">
              <p class="lead" v-if="historicos == undefined || historicos.length == 0">
                Não há comentários disponíveis nesta demanda.
              </p>
              <b-list-group>
                <template v-for="hist in historicos">
                  <b-list-group-item
                    v-if="hist.seqHistoricoOrigem"
                    :key="'hst-resposta-' + hist.id.sequencia"
                    class="flex-column align-items-start ml-5 mb-3 px-3 py-2"
                    style="border-left: 3px solid #888888; background-color: #f5f5f5;"
                  >
                    <div class="d-flex w-100 justify-content-between mb-2">
                      <div>
                        <span class="badge badge-default">Resposta</span>
                      </div>
                      <div style="font-size: 0.9em;">
                        <font-awesome-icon icon="calendar-alt" />
                        {{ hist.datHorHistorico | formatDate }}
                      </div>
                    </div>

                    <div class="d-flex w-100 justify-content-between">
                      <div class="flex-grow-1">
                        <div>
                          <AccountDetails v-if="hist.origem == 1" class="mr-1" title="Concessionária" />
                          <AccountTie v-if="hist.origem == 2" class="mr-1" title="Agência reguladora" />
                          <AccountGroup v-if="hist.origem == 3" class="mr-1" title="Usuário(s) demandas" />
                          <span>{{ hist.descricao }}</span>
                        </div>
                      </div>
                      <div class="text-right" style="min-width: 150px; margin-left: 10px;">
                        <div v-if="hist.anexo !== undefined" class="text-muted mb-1" style="font-size: 0.85em;">
                          {{ hist.anexo.nome }}
                        </div>
                        <div v-if="hist.anexo !== undefined">
                          <a
                            href="#"
                            @click="downloadDocto(hist.anexo)"
                            v-b-tooltip.hover
                            title="Baixar"
                            class="nav-item"
                            target="_blank"
                          >
                            <font-awesome-icon icon="file-download" />
                            <span class="ml-1">Baixar</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item
                    v-else
                    :key="'hst-comentario-' + hist.id.sequencia"
                    class="flex-column align-items-start px-3 py-2"
                    href="#"
                  >
                    <div class="d-flex w-100 justify-content-between mb-2">
                      <div>
                        <span v-if="hist.id.versao !== undefined" class="badge badge-default">
                          Revisão {{ hist.id.versao }}
                        </span>
                      </div>
                      <div style="font-size: 0.9em;">
                        <font-awesome-icon icon="calendar-alt" />
                        {{ hist.datHorHistorico | formatDate }}
                      </div>
                    </div>

                    <div class="d-flex w-100 justify-content-between">
                      <div class="flex-grow-1">
                        <div>
                          <AccountDetails v-if="hist.origem == 1" class="mr-1" title="Concessionária" />
                          <AccountTie v-if="hist.origem == 2" class="mr-1" title="Agência reguladora" />
                          <AccountGroup v-if="hist.origem == 3" class="mr-1" title="Usuário(s) demandas" />
                          <span>{{ hist.descricao }}</span>
                        </div>
                      </div>
                      <div class="text-right" style="min-width: 150px; margin-left: 10px;">
                        <div v-if="hist.anexo !== undefined" class="text-muted mb-1" style="font-size: 0.85em;">
                          {{ hist.anexo.nome }}
                        </div>
                        <div v-if="hist.anexo !== undefined">
                          <a
                            href="#"
                            @click="downloadDocto(hist.anexo)"
                            v-b-tooltip.hover
                            title="Baixar"
                            class="nav-item"
                            target="_blank"
                          >
                            <font-awesome-icon icon="file-download" />
                            <span class="ml-1">Baixar</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-list-group-item>
                </template>
              </b-list-group>
            </div>
          </b-col>
        </b-row>

        <b-modal id="publishModal" title="Incluir comentário" hide-footer scrollable size="xl" @show="getTiposArquivos">
          <b-row>
            <b-col cols="12">
              <b-form-textarea
                class="form-control mb-2"
                rows="5"
                cols="180"
                placeholder="Adicionar comentário..."
                v-model="comentario"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                class="mt-2"
                :show-empty="true"
                v-if="demanda.statusInfo.permitirComentario === 1"
                :fields="fieldsAnexos"
                :items="anexos"
                empty-text="Não há dados disponíveis."
              >
                <template #cell(nomeArquivo)="row">
                  <div>
                    {{ row.item.nomeArquivo }}
                  </div>
                </template>
                <template #cell(tipoArquivo)="row">
                  {{ getTipoArquivo(row.item) }}
                </template>
                <template #cell(arquivo)="row">
                  <div class="d-flex flex-column align-items-center w-100">
                    <div class="d-flex align-items-center anexo-centralizado w-100 justify-content-center">
                      <span v-if="row.item.uploadedFile" class="arquivo-borda nome-arquivo-centralizado">
                        {{ row.item.uploadedFile.name }}
                      </span>
                      <b-button
                        v-if="row.item.uploadedFile"
                        variant="danger"
                        size="sm"
                        class="ml-2"
                        @click="removeAnexo(row.item)"
                        title="Remover arquivo"
                        style="line-height:1; padding: 0 4px; height: 22px; min-width: 22px; border-width: 1.5px;"
                      >
                        <i class="fa fa-trash" style="font-size: 0.85em;"></i>
                      </b-button>
                      <b-form-file
                        v-else
                        v-model="row.item.uploadedFile"
                        placeholder="Selecione o arquivo"
                        browse-text="Escolher"
                        :state="validateStateAnexo(row.item.id.sequencia)"
                        :id="'arquivo-' + row.item.id.sequencia"
                        :name="'arquivo-' + row.item.id.sequencia"
                        :ref="'fileInput-' + row.item.id.sequencia"
                        :aria-describedby="'arquivo-feedback-' + row.item.id.sequencia"
                        :accept="getTypeFile(row.item.tipoArquivo)"
                        @input="onUploadAnexos($event, row.item.id.sequencia)"
                        class="w-100"
                      />
                    </div>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" class="d-flex justify-content-end">
              <n-button type="primary" round size="md" class="mr-3" @click="handlePublish">
                <font-awesome-icon icon="comment" />
                <span class="ml-1">Publicar</span>
              </n-button>

              <n-button type="secondary" round size="md" @click="handleCancel">
                <font-awesome-icon icon="window-close" />
                <span class="ml-1">Cancelar</span>
              </n-button>
            </b-col>
          </b-row>
        </b-modal>

        <b-modal id="mapModal" size="xl" title="Localização da demanda: ">
          <mapas :demanda="demanda" :kmlData="kmlData"></mapas>
        </b-modal>
      </form>

      <div class="separator separator-primary"></div>
    </div>

    <b-modal hide-footer hide-header size="sm" id="modalProcesso" centered>
      <b-row>
        <b-col>
          <div class="text-center text-info my-2 align-middle">
            <b-spinner class="align-middle"></b-spinner>
            <span class="ml-3">Aguarde, processando a requisição...</span>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import { Button, FormGroupInput } from '@/components';
import Mapa from '@/pages/Mapa.vue';
import AccountDetails from 'vue-material-design-icons/AccountDetails';
import AccountGroup from 'vue-material-design-icons/AccountGroup';
import AccountTie from 'vue-material-design-icons/AccountTie';

import numeral from 'numeral';
import 'numeral/locales';

export default {
  name: 'demanda',
  bodyClass: 'demanda-page',
  components: {
    AccountGroup,
    AccountDetails,
    AccountTie,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Mapa.name]: Mapa
  },
  data() {
    return {
      backgroundTopo: "background-image: url('/img/solicitacao.jpg')",
      formatter: undefined,
      idDemanda: 0,

      pagamento: false,
      refCodeDemandas: {},

      demanda: {
        titulo: null,
        nroProtocolo: null,
        kmInicial: null,
        kmFinal: null,
        objetivo: { descricao: null },
        cidade: { cidade: { descricao: null } },
        rodovia: { rodovia: { descricao: null } },
        trecho: { descricao: null },
        tipo: { descricao: null },
        area: { descricao: null },
        status: null,
        statusInfo: { descricao: null },
        usuario: { nome: null },
        isentoPagamento: 0
      },
      isCriador: false,
      infoCidade: undefined,
      infoSegmento: undefined,
      historicos: [],
      kmlData: [],
      comentario: '',
      file: null,
      observacao: '',
      tipoAnexo: 'PB',
      tipoDemanda: this.$store.state.account.tipo,
      labelTipo: 'Tipo:',
      labelObjetivo: 'Objetivo:',

      hiddenFields: Vue.prototype.$externalConfig.HIDDEN_FIELDS,

      // Modal comentários
      files: [],
      anexos: [],
      fieldsAnexos: [
        { key: 'nomeArquivo', label: 'Nome/Descrição do arquivo', thStyle: { width: '40%' }, tdClass: 'align-middle' },
        {
          key: 'arquivo',
          label: 'Arquivo',
          thStyle: { width: '35%' },
          tdClass: 'align-middle',
          thClass: 'text-center'
        },
        {
          key: 'tipoArquivo',
          label: 'Tipo',
          thStyle: { width: '15%' },
          tdClass: 'align-middle text-center',
          thClass: 'text-center'
        }
      ],
      uploadedFile: null,
      uploadedFileComprovante: null,
      tiposAnexo: [],
      anexosInvalidos: [],

      optionsArquivo: [
        {
          id: 1,
          descricao: 'Arquivo PDF'
        },
        {
          id: 2,
          descricao: 'Documento Texto (DOCX)'
        },
        {
          id: 3,
          descricao: 'Planilha Eletrônica (XLSX)'
        },
        {
          id: 4,
          descricao: 'Imagem (PNG/JPG/BMP)'
        },
        {
          id: 5,
          descricao: 'PowerPoint (PPT)'
        },
        {
          id: 6,
          descricao: 'E-mail (MSG/EML)'
        },
        {
          id: 7,
          descricao: 'Arquivo compactado (ZIP/RAR)'
        },
        {
          id: 8,
          descricao: 'Projeto CAD (DWG/DXF)'
        },
        {
          id: 9,
          descricao: 'Arquivo KMZ'
        }
      ],

      anexosPagamento: []
    };
  },
  computed: {
    versaoAtual() {
      if (!this.demanda.versoes || this.demanda.versoes.length === 0) {
        return 0;
      }
      // Para encontrar a maior versão existente
      return Math.max(...this.demanda.versoes.map(v => v.id.versao));
    },
    ...mapState('empresa', ['empresas', 'empresaAtual']),
    rows() {
      return this.dadosAdicionais.length;
    }
  },
  mounted() {
    if (window.config) {
      if (window.config.SIGLA_ASSETS) {
        const siglaAssets = window.config.SIGLA_ASSETS;
        this.backgroundTopo = `background-image: url('/img/${siglaAssets}/solicitacao.jpg')`;
      }

      if (window.config.LABELS) {
        this.labelTipo = window.config.LABELS.demanda.tipo;
        this.labelObjetivo = window.config.LABELS.demanda.objetivo;
      }
    }

    numeral.locale('pt-br');
    this.formatter = numeral;

    this.loadData();
  },
  methods: {
    downloadDocto(anexo) {
      this.$bvModal.show('modalProcesso');

      const token = this.$store.state.account.user;
      const requestCfg = {
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      };

      const siglaEmpresa = this.$store.state.empresa.empresaAtual.sigla;
      const modulo = 'DEM';

      Vue.axios
        .get(`/downloads/${siglaEmpresa}/anexos/${modulo}/${anexo.uuid}`, requestCfg)
        .then(response => {
          this.downloadFile(new Blob([response.data]), anexo.nome);
          this.$bvModal.hide('modalProcesso');
        })
        .catch(error => {
          this.$bvModal.hide('modalProcesso');
          this.showErrorNotify('Erro', error.data ? error.data : error);
        });
    },
    downloadFile(blob, fileName) {
      const link = document.createElement('a');
      // create a blobURI pointing to our Blob
      link.href = URL.createObjectURL(blob);
      if (fileName) link.download = fileName;
      link.target = '_blank';
      // some browser needs the anchor to be in the doc
      document.body.appendChild(link);
      link.click();
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 6000);
    },
    solicitarComprovanteAbertura() {
      const token = this.$store.state.account.user;
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const idDemanda = this.demanda.id ? this.demanda.id.idDemanda : this.$route.params.idDemanda;

      const requestCfg = {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      };

      this.$bvModal.show('modalProcesso');

      Vue.axios
        .get(`/faixasDominio/relatorios/${sigla}/${idDemanda}/recibo-protocolo`, requestCfg)
        .then(response => {
          const fileName = `recibo-protocolo-${this.demanda.nroProtocolo || idDemanda}.pdf`;
          this.downloadFile(new Blob([response.data]), fileName);
          this.$bvModal.hide('modalProcesso');
        })
        .catch(() => {
          this.$bvModal.hide('modalProcesso');
          this.$notify({
            group: 'msgs',
            title: 'Erro',
            text: 'Não foi possível emitir o comprovante de abertura da solicitação.',
            type: 'error'
          });
        });
    },
    getMediaUrl(idEmpresa, uuid) {
      const serverUrl =
        process.env.NODE_ENV === 'production' ? window.config.VUE_APP_API_LOCATION : process.env.VUE_APP_API_LOCATION;
      return `${serverUrl}/viewFile?idEmpresa=${idEmpresa}&uuid=${uuid}`;
    },
    getFaixaDemanda() {
      if (this.demanda == null || this.demanda === undefined) {
        return '';
      }

      if (this.demanda.faixa === 'FAIXA_1') {
        return '1';
      } else if (this.demanda.faixa === 'FAIXA_2') {
        return '2';
      } else if (this.demanda.faixa === 'FAIXA_3') {
        return '3';
      } else if (this.demanda.faixa === 'FAIXA_4') {
        return '4';
      } else if (this.demanda.faixa === 'FAIXA_5') {
        return '5';
      } else if (this.demanda.faixa === 'FAIXA_6') {
        return '6';
      } else if (this.demanda.faixa === 'ACOSTAMENTO_INTERNO') {
        return 'Acostamento Interno';
      } else if (this.demanda.faixa === 'ACOSTAMENTO_EXTERNO') {
        return 'Acostamento Externo';
      }

      return '';
    },
    getIndiceFmt(valor) {
      return numeral(valor).format('#,###.#');
    },
    getLocalDemanda() {
      if (this.demanda == null || this.demanda === undefined) {
        return '';
      }

      if (this.demanda.local === 'EIXO_TRONCAL') {
        return 'Eixo Troncal';
      } else if (this.demanda.local === 'MARGINAL_DIREITA') {
        return 'Marginal Direita';
      } else if (this.demanda.local === 'MARGINAL_ESQUERDA') {
        return 'Marginal Esquerda';
      } else if (this.demanda.local === 'DISPOSITIVO') {
        return 'Dispositivo';
      }

      return '';
    },
    getNomenclaturaAlca() {
      if (this.demanda == null || this.demanda === undefined) {
        return '';
      }

      const alcas = [];
      // Fill Nomenclaturas : Ramos
      for (let i = 100; i <= 900; i += 100) {
        alcas.push({ value: 'RAMO_' + i, text: 'Ramo ' + i });
      }

      // Fill Nomenclaturas : Rotatórias
      for (let i = 100; i <= 900; i += 100) {
        alcas.push({ value: 'ROTATORIA_', text: 'Rotatória ' + i });
      }

      for (let i = 0; i < alcas.length; i++) {
        if (alcas[i].value == this.demanda.nomenclaturaAlca) {
          return alcas[i].text;
        }
      }

      return '';
    },
    getSentido() {
      if (this.demanda.sentido == undefined) return '';
      if (this.demanda.sentido == 'N') return 'Norte';
      else if (this.demanda.sentido == 'S') return 'Sul';
      else if (this.demanda.sentido == 'L') return 'Leste';
      else if (this.demanda.sentido == 'O') return 'Oeste';
      else if (this.demanda.sentido == 'D') return 'Decrescente';
      else if (this.demanda.sentido == 'C') return 'Crescente';
    },
    loadData() {
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const idDemanda = this.$route.params.idDemanda;

      Vue.axios
        .get(`/faixasDominio/${sigla}/${idDemanda}`, options)
        .then(response => {
          this.demanda = response.data.demanda;
          this.isCriador = response.data.isCriador === true;

          if (this.demanda.objetivo.pagamento == 'S') {
            this.pagamento = true;
            this.getRefCodeDemandas();
          }

          if (this.demanda.usuario == undefined) {
            this.demanda.usuario = {};
          }

          if (response.data.demanda.area == undefined) {
            if (response.data.area == undefined) {
              this.demanda.area = {};
            }
          }

          if (response.data.historicos != undefined) {
            this.historicos = response.data.historicos;
          }

          if (response.data.cidade != undefined) {
            this.infoCidade = response.data.cidade;
          }

          if (response.data.segmento != undefined) {
            this.infoSegmento = response.data.segmento;
          }

          this.getAnexosByFaixaDominio();
        })
        .catch(error => {
          this.$notify({
            group: 'msgs',
            title: 'Catch',
            text: error,
            type: 'error'
          });
        });
    },
    getRefCodeDemandas() {
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const refName = 'DEMANDA.PAGAMENTO_OBSERVACAO';

      Vue.axios
        .get(`/core/refCodes/${sigla}?search=${refName}`, options)
        .then(response => {
          if (response.data.length != 0) {
            this.refCodeDemandas = response.data[0];
          }
        })
        .catch(error => {
          this.$notify({
            group: 'msgs',
            title: 'Catch',
            text: error,
            type: 'error'
          });
        });
    },
    handleCancel() {
      this.$bvModal.hide('publishModal');
    },
    handlePublish() {
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const token = this.$store.state.account.user;
      const idDemanda = this.$route.params.idDemanda;
      const requestOpts = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      };

      if (this.comentario == '') {
        this.$notify({
          group: 'msgs',
          title: 'Error',
          text: 'Digite o comentário',
          type: 'error'
        });
        return;
      }

      this.anexosInvalidos = [];

      //para mostrar o modal de carregamento após um tempo
      this.$nextTick(() => {
        this.$bvModal.show('modalProcesso');
      });

      const formData = new FormData();

      formData.append('comentario', this.comentario);

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i]);
      }

      for (var x = 0; x < this.tiposAnexo.length; x++) {
        formData.append('tiposArquivos', this.tiposAnexo[x]);
      }

      Vue.axios
        .post(`/faixasDominio/${sigla}/${idDemanda}/publicar`, formData, requestOpts)
        .then(response => {
          this.$bvModal.hide('modalProcesso');
          this.comentario = '';
          this.historicos = response.data;
          this.$notify({
            group: 'msgs',
            title: 'Sucesso',
            text: 'Comentário enviado com sucesso!',
            type: 'info'
          });

          this.$bvModal.hide('publishModal');
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        })
        .catch(error => {
          this.$bvModal.hide('modalProcesso');
          this.$bvModal.show('publishModal');
          this.$notify({
            group: 'msgs',
            title: 'Erro',
            text: error.response && error.response.data.message ? error.response.data.message : error,
            type: 'error'
          });
        });
    },
    toggleMapDialog() {
      this.$bvModal.show('mapModal');
    },
    getTiposArquivos() {
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      this.anexos = [];

      if (this.demanda.idTipo !== null) {
        Vue.axios.get(`/demandas/${this.empresaAtual.sigla}/tipos/${this.demanda.idTipo}`, options).then(response => {
          const arquivos = response.data.arquivos;
          if (arquivos.length > 0) {
            for (const arquivo of arquivos) {
              this.anexos.push(arquivo);
            }
          }
        });
      }
    },
    getTipoArquivo(item) {
      let text = '';

      for (const arquivo of this.optionsArquivo) {
        if (arquivo.id === item.tipoArquivo) {
          text = arquivo.descricao;
        }
      }

      return text;
    },
    getTypeFile(typeFile) {
      let type = '';

      if (typeFile === 1) {
        // Arquivo PDF
        type = '.pdf';
      } else if (typeFile === 2) {
        // Documento de Texto (DOCX)
        type = '.doc, .docx';
      } else if (typeFile === 3) {
        // Planilha Eletrônica (XLSX)
        type = '.xlsx, .xlsm, .xls, .csv';
      } else if (typeFile === 4) {
        // Imagem (PNG/JPG/BMP)
        type = 'image/*';
      } else if (typeFile === 5) {
        // PowerPoint (PPT)
        type = '.pptx, .ppt';
      } else if (typeFile === 6) {
        // E-mail (MSG/EML)
        type = '.eml, .msg';
      } else if (typeFile === 7) {
        // Arquivo Compactado (ZIP/RAR)
        type = '.bzip2, .gzip, .tar, .wim, .7z';
      } else if (typeFile === 8) {
        // Projeto CAD (DWG/DXF)
        type = '.dwg, .dxf';
      } else if (typeFile === 9) {
        // Arquivo KMZ
        type = '.kml, .kmz, .csv, .tsv, .gpx, .xlsx';
      }

      return type;
    },
    onUploadAnexos(file, sequencia) {
      if (file != undefined) {
        // Remove o arquivo anterior se tiver
        const fileIndex = this.files.findIndex(f => f.sequencia === sequencia);
        if (fileIndex > -1) {
          this.files.splice(fileIndex, 1);
        }
        // Remove o tipo de anexo anterior se tiver
        const tipoIndex = this.tiposAnexo.indexOf(sequencia);
        if (tipoIndex > -1) {
          this.tiposAnexo.splice(tipoIndex, 1);
        }
        // Adiciona novo arquivo com sequência
        file.sequencia = sequencia;
        this.files.push(file);
        this.tiposAnexo.push(sequencia);
        // Remove da lista os anexos que não estão corretos da sequência
        const invalidIndex = this.anexosInvalidos.indexOf(sequencia);
        if (invalidIndex > -1) {
          this.anexosInvalidos.splice(invalidIndex, 1);
        }
        const anexo = this.anexos.find(a => a.id.sequencia === sequencia);
        if (anexo) {
          anexo.uploadedFile = file;
        }
      }
    },
    removeAnexo(anexoItem) {
      const sequencia = anexoItem.id.sequencia;
      // Remove o arquivo da lista
      const fileIndex = this.files.findIndex(f => f.sequencia === sequencia);
      if (fileIndex > -1) {
        this.files.splice(fileIndex, 1);
      }
      // Remove o tipo de anexo
      const tipoIndex = this.tiposAnexo.indexOf(sequencia);
      if (tipoIndex > -1) {
        this.tiposAnexo.splice(tipoIndex, 1);
      }
      // Limpa o arquivo do anexo
      anexoItem.uploadedFile = null;
    },
    validateStateAnexo(sequencia) {
      if (this.anexosInvalidos.includes(sequencia)) {
        return false;
      }
      return null;
    },

    onUploadComprovante(file, tipo) {
      let label = undefined;
      if (tipo === 'CP1') {
        label = 'Comprovante de pagamento - Taxa PAV.pdf';
      } else if (tipo === 'CP2') {
        label = 'Comprovante de pagamento - Taxa PEP.pdf';
      }

      const anexo = new File([file], label, { type: 'application/pdf' });

      const formData = new FormData();
      formData.append('file', anexo);

      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const token = this.$store.state.account.user;
      const requestOpts = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      };

      Vue.axios
        .post(
          `/faixasDominio/${sigla}/${this.demanda.id.idDemanda}/anexos/comprovantes?tipo=${tipo}`,
          formData,
          requestOpts
        )
        .then(response => {
          console.log(response.data);
          this.loadData();
        })
        .catch(error => {
          const errorMsg = error.response ? error.response.data.message : error;
          this.$notify({
            group: 'msgsCenter',
            title: 'Erro',
            text: errorMsg,
            type: 'error'
          });
        });
    },

    getValorPagamento(valor) {
      return numeral(valor).format('###.##');
    },

    getAnexosByFaixaDominio() {
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const token = this.$store.state.account.user;
      const requestOpts = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      Vue.axios
        .get(`/faixasDominio/${sigla}/${this.demanda.id.idDemanda}/anexos`, requestOpts)
        .then(response => {
          this.anexosPagamento = response.data;
        })
        .catch(error => {
          const errorMsg = error.response ? error.response.data.message : error;
          this.$notify({
            group: 'msgsCenter',
            title: 'Erro',
            text: errorMsg,
            type: 'error'
          });
        });
    },

    getTipoArquivoPagamento(tipo) {
      let anexo = {};
      for (const anx of this.anexosPagamento) {
        if (anx.tipoAnexo === tipo) {
          anexo = anx;
        }
      }
      return anexo;
    },

    hasHiddenField(fieldName) {
      if (this.hiddenFields == undefined || this.hiddenFields == null) return true;

      let hiddenFields = false;

      for (const value of this.hiddenFields) {
        if (value == fieldName) {
          hiddenFields = true;
        }
      }

      return hiddenFields;
    }
  }
};
</script>

<style scoped>
.listaPrioriza {
  list-style-type: none;
  columns: 2;
  -webkit-columns: 2;
  -moz-columns: 2;
}

.anexo-centralizado {
  min-height: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nome-arquivo-centralizado {
  display: flex;
  align-items: center;
  font-size: 1em;
  margin: 0;
  height: 100%;
}

.arquivo-borda {
  border: 1.5px solid #ced4da;
  border-radius: 0.25rem;
  padding: 2px 8px 2px 12px;
  background: #fff;
  font-size: 1em;
  min-width: 120px;
  text-align: center;
  display: flex;
  align-items: center;
  height: 28px;
  gap: 4px;
}

.btn-excluir-arquivo {
  border: none;
  background: #e9ecef;
  border-radius: 0.25rem;
  height: 28px;
  width: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  margin-left: auto;
}

.btn-excluir-arquivo:hover {
  background: #dee2e6;
}

.icone-lixeira-vermelha {
  color: #dc3545 !important;
}

.b-table tbody td {
  vertical-align: middle !important;
}

.b-form-file {
  min-width: 220px;
  max-width: 320px;
  margin: 0 8px;
}

.b-form-invalid-feedback {
  text-align: center;
}

@media (max-width: 900px) {
  .b-form-file {
    min-width: 120px;
    max-width: 100%;
  }
}

.b-table th,
.b-table td {
  vertical-align: middle !important;
  text-align: left;
}

.b-table th.text-center,
.b-table td.text-center {
  text-align: center !important;
}
</style>
